import { Icon } from "@platform/ui/components";
import { twMerge } from "tailwind-merge";
import { useUserProfile } from "~/shared/api/users/users.queries";

export function ProductTeamProductionWarning() {
  const { data: user } = useUserProfile();
  const isProduction = window.location.hostname === "app.breakline.org";

  if (isProduction && user?.roles.includes("product")) {
    return <WarningPanel />;
  }

  return null;
}

function WarningPanel() {
  return (
    <div
      className={twMerge(
        "fixed bottom-8 left-1/2 z-50 -translate-x-1/2",
        "flex items-center gap-2 py-3 pr-5 pl-4",
        "bg-ds-red-11 rounded-md text-white shadow-md",
        "animate-in fade-in-0 slide-in-from-bottom-4 duration-300 ease-out",
      )}
    >
      <Icon symbol="error-warning-line" />
      <span className="text-sm font-semibold">
        Hey Product Team, this is <strong className="font-bold">production</strong>. Please be careful!
      </span>
    </div>
  );
}
